"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasskeyBindSession = void 0;
const rxjs_1 = require("rxjs");
const AccountService_1 = require("../AccountService");
const BasePasskeySession_1 = require("./BasePasskeySession");
class PasskeyBindSession extends BasePasskeySession_1.BasePasskeySession {
    constructor(params) {
        super(params, AccountService_1.VerifyCodeAction.passkey_registration);
    }
    start(txn_id, ext) {
        super.startSession((mfaParams) => {
            return (0, rxjs_1.from)(this.params.buAccount.bindPasskey({
                txn_id: mfaParams.txn_id,
            }, this.sessionHandler));
        }, txn_id, ext);
    }
}
exports.PasskeyBindSession = PasskeyBindSession;
